import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="clicker"
export default class extends Controller {
  static targets = ["element"];
  declare elementTarget;

  click() {
    this.elementTarget.click();
  }
}
